import hideDialogAndInvokeCallbackOnError from '../utils/hideDialogAndInvokeCallbackOnError';
import hideDialogAndTriggerTokenFlowOnSuccess from '../utils/hideDialogAndTriggerTokenFlowOnSuccess';
import OmexResultCode from '../schema/OmexResultCode';
import { getSsoDialog } from 'owa-addins-store';
import { SsoErrorCode } from '../schema/SsoErrorCode';

export default function onOmexConsentMessage(result: OmexResultCode): void {
    switch (result) {
        case OmexResultCode.Success:
            const dialog = getSsoDialog();
            hideDialogAndTriggerTokenFlowOnSuccess(dialog.controlId, dialog.authChallenge);
            break;
        case OmexResultCode.Cancelled:
            hideDialogAndInvokeCallbackOnError(SsoErrorCode.UserAborted);
            break;
        default:
            hideDialogAndInvokeCallbackOnError(SsoErrorCode.InvalidGrant);
    }
}
